import { renderMessageBar_unstable } from '@fluentui/react-message-bar';

/**
 * Renders the final JSX of the MessageBar component, given the state and context values.
 */
export const renderMessageBar = renderMessageBar_unstable;
